export function checkIfValuesNull(array) {
    return array.some(item => item.value === null);
}
